module.exports = __webpack_public_path__ + "static/img/p2.2691feb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner/p2.png
// module id = N5Fo
// module chunks = 0